"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _reactDatepicker = _interopRequireWildcard(require("react-datepicker"));
var _fr = _interopRequireDefault(require("date-fns/locale/fr"));
var _useRandomId = _interopRequireDefault(require("../../hooks/useRandomId"));
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
var _useLabel = _interopRequireDefault(require("../../hooks/useLabel"));
var _dateFns = require("date-fns");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } /* eslint-disable no-nested-ternary */ /* eslint-disable no-self-compare */
(0, _reactDatepicker.registerLocale)('fr', _fr.default);
(0, _reactDatepicker.registerLocale)('fr-FR', _fr.default);
(0, _reactDatepicker.registerLocale)('fr-CA', _fr.default);
const dateShape = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.instanceOf(Date)]);
function inputFormat(date) {
  // Return null if date formate is invalidate format
  if (date && isNaN(new Date(date).valueOf())) {
    return null;
  }

  // Data in Date format
  if (date && (date instanceof Date || new Date(date) instanceof Date)) {
    // Return JavaScript timestamp in milliseconds
    return new Date(date);
  }
  return null;
}
const outputFormat = date => {
  if (date && date instanceof Date) {
    return date.getTime();
  }
  return null;
};

/**
 * The InputTime component allows an user to select a date and/or time in a determined format.
 *
 * This component is an opinionated wrapper around <a href="https://github.com/Hacker0x01/react-datepicker/" target="_blank">React Datepicker</a>
 */
const InputTime = props => {
  const {
    id: controlledId,
    name,
    value: controlledTime,
    label: initialLabel,
    placeholder,
    helper,
    floatLabel,
    clearable,
    locale,
    withIcon,
    readOnly,
    disabled,
    required,
    onChange,
    onError,
    className,
    displayAsText,
    labelAria,
    minTime,
    maxTime,
    timeIntervals,
    ...attributes
  } = props;
  const datePickerRef = _react.default.useRef(null);
  const id = (0, _useRandomId.default)(controlledId);
  const [time, setTime] = _react.default.useState(inputFormat(controlledTime) || null);
  const [timeOutput, setTimeOuput] = _react.default.useState(controlledTime || null);
  const [hasFocus, setFocus] = _react.default.useState(false);
  const {
    label
  } = (0, _useLabel.default)(initialLabel, {
    ...props,
    id,
    value: time
  });
  _react.default.useEffect(() => {
    setTime(inputFormat(controlledTime));
    setTimeOuput(controlledTime);
  }, [controlledTime]);
  const handleChange = updatedTime => {
    const hours = updatedTime.getHours();
    const minutes = updatedTime.getMinutes();
    updatedTime = (0, _dateFns.hoursToMilliseconds)(hours) + (0, _dateFns.minutesToMilliseconds)(minutes);
    const time = new Date(updatedTime + new Date(updatedTime).getTimezoneOffset() * 60 * 1000);
    setTime(time);
    if (typeof onChange === 'function') {
      onChange(outputFormat(time), datePickerRef.current.props.name);
    }
  };
  const handleOnClear = () => {
    setTime(null);
    if (typeof onChange === 'function') {
      onChange(null, datePickerRef.current.props.name);
    }
  };
  const handleClickOutside = () => {
    datePickerRef.current.setOpen(false);
  };
  if (displayAsText) {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: className
    }, new Intl.DateTimeFormat(locale, {
      hour: '2-digit',
      minute: '2-digit'
    }).format(timeOutput));
  }
  const handleFocus = () => {
    setFocus(true);
  };
  const handleBlur = () => {
    setFocus(false);
  };
  const handleMinTime = timeLeft => {
    const [minHours, minMinutes] = timeLeft.toString().split('.');
    return (0, _dateFns.setHours)((0, _dateFns.setMinutes)(new Date(), minMinutes || 0), minHours);
  };
  const handleMaxTime = timeRight => {
    const [maxHours, maxMinutes] = timeRight.toString().split('.');
    return (0, _dateFns.setHours)((0, _dateFns.setMinutes)(new Date(), maxMinutes || 59), maxHours);
  };
  const containerClasses = (0, _clsx.default)('uk-form-item', 'uk-input', 'uk-datepicker', 'uk-datepicker__time', helper.length > 0 && 'has-helper',
  // errors.length > 0 && 'has-error',
  (disabled || readOnly) && 'is-frozen', clearable && time && 'is-clearable', hasFocus && 'has-focus', className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: containerClasses
  }, label, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex-container"
  }, /*#__PURE__*/_react.default.createElement(_reactDatepicker.default, _extends({
    className: "uk-inputtable",
    ref: datePickerRef,
    id: id,
    name: name || id,
    selected: time || null,
    placeholderText: !floatLabel ? (placeholder || locale) && locale.split('-')[0] === 'fr' ? 'HH:mm' || '' : 'h:mm aa' || '' : undefined,
    autoComplete: "off",
    disabled: disabled,
    readOnly: readOnly,
    required: required,
    onChange: handleChange,
    onClickOutside: handleClickOutside,
    showTimeSelect: true,
    showTimeSelectOnly: true,
    timeIntervals: timeIntervals,
    timeCaption: "",
    minTime: handleMinTime(minTime),
    maxTime: handleMaxTime(maxTime),
    tabIndex: 0,
    popperPlacement: "bottom-end",
    popperModifiers: [{
      name: 'preventOverflow',
      options: {
        enabled: true,
        escapeWithReference: false,
        boundariesElement: 'viewport'
      }
    }],
    locale: locale ? locale.split('-')[0] : null,
    dateFormat: locale && locale.split('-')[0] === 'fr' ? 'HH:mm' || '' : 'h:mm aa' || '',
    onFocus: handleFocus,
    onBlur: handleBlur
  }, attributes)), withIcon && (!clearable || !time) && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "clock"
  }), clearable && time && /*#__PURE__*/_react.default.createElement("div", {
    "aria-hidden": "true",
    className: "uk-input__clearButton",
    onClick: handleOnClear
  }, "\xD7")));
};
InputTime.propTypes = {
  /**
   * ID of the DatePicker (used to bind the label to its input field)
   * NB: the ID will be randomly generated if not set.
   */
  id: _propTypes.default.string,
  /**
   * Name of the DatePicker (used instead of the ID when submitted)
   */
  name: _propTypes.default.string,
  /**
   * Default value of the DatePicker
   */
  value: _propTypes.default.oneOfType([dateShape, _propTypes.default.arrayOf(dateShape)]),
  /**
   * Label of the DatePicker
   */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  /**
   * DatePicker placeholder
   */
  placeholder: _propTypes.default.string,
  /**
   * Helper text, is replaced by a message in case of error
   */
  helper: _propTypes.default.string,
  /**
   * Remove the placeholder (if any), replace it with a floating label
   */
  floatLabel: _propTypes.default.bool,
  /**
   * Set the time formatting depending on the locale
   * (e.g. 'en', 'en-CA', 'en_CA', etc.)
   */
  locale: _propTypes.default.oneOf(['en', 'fr']),
  /**
   * Add a decorative calendar icon to the DatePicker
   */
  withIcon: _propTypes.default.bool,
  /**
   * Add a button to clear the DatePicker
   */
  clearable: _propTypes.default.bool,
  /**
   * Set the DatePicker as read-only
   */
  readOnly: _propTypes.default.bool,
  /**
   * Set the DatePicker as disabled
   */
  disabled: _propTypes.default.bool,
  /**
   * Form-validation: set the DatePicker as required
   */
  required: _propTypes.default.bool,
  /**
   * Callback function onChange
   */
  onChange: _propTypes.default.func,
  /**
   * Callback function onError
   */
  onError: _propTypes.default.func,
  /**
   * Display the value as a text
   */
  displayAsText: _propTypes.default.bool,
  /**
   * Provide text to labelAria only if props label is omitted.
   */
  labelAria: _propTypes.default.string,
  /**
   * Disable non-working hours.
   * Provide the later time. An integer between 0 and 23.59. Start counting from Midnight 00:00(12:00 AM)
   */
  minTime: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  /**
   * Disable non-working hours.
   * Provide the earlier time. An integer between 0 and 23.59. Start counting from Midnight 00:00(12:00 AM)
   */
  maxTime: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  /**
   * Set minutes interval between 1 and 60
   */
  timeIntervals: _propTypes.default.oneOf(['5', '10', '15', '30', '60'])
};
InputTime.defaultProps = {
  placeholder: '',
  helper: '',
  floatLabel: false,
  withIcon: true,
  readOnly: false,
  disabled: false,
  required: false,
  clearable: false,
  minTime: 8,
  maxTime: 17,
  timeIntervals: '30'
};
var _default = exports.default = InputTime;